export enum SplitterMsgData {
  DEFAULT_SIZE_AND_MIN = 400,
  SIZE = 350,
}
